export enum Path {
	Home = '/',
}
